import { BidderCreativeStatus } from '@openx/types/gqlTypes';
import type { TFunction } from 'i18next';
import { array, mixed, string } from 'yup';

export const getBaseFieldsValidation = (t: TFunction) => ({
  account_uid: string().trim().required(t('Advertiser is required')).typeError(t('Advertiser is required')),
  name: string()
    .trim()
    .required(t('Name is required'))
    .max(255, t('Name exceeds the maximum number of characters allowed')),
  status: mixed<BidderCreativeStatus>()
    .oneOf(Object.values(BidderCreativeStatus), t('Please select a valid status'))
    .required(t('Status is required')),
  markup_payload: string().required(t('Markup payload is required')),
  crid: string().required(t('CRID is required')).max(100, t('CRID exceeds the maximum number of characters allowed')),

  iab_categories: array()
    .of(string().trim().min(1, t('IAB category cannot be empty')).defined())
    .defined(),
  advertiser_domain: string().defined(),
});
